import React from 'react'
import { connect } from 'react-redux'
import { Button, Modal } from 'semantic-ui-react'
import { getFormValues, Field } from 'redux-form'
import * as v from 'variables/styles'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'
import { SummaryContainer, Cont } from './styled'
import { RowFields } from '../../styled'
import { unlockPoSAP, reloadPoSAP, getVendorStatus } from 'ducks/purchaseOrder'
import { codeOfConductDetailsPath } from 'routes'

const PurchaseOrderSummary = (props) => {
  const { valueForm, vendorStatus } = props
  const { vendorCode } = valueForm

  React.useEffect(()=>{
    if(valueForm&&valueForm.vendorCode){
      props.getVendorStatus(valueForm.vendorCode)
    }
  },[valueForm&&valueForm.vendorCode])

  const checkShowReloadSAP = ()=>{
    if(valueForm){
      // if(valueForm.status==5||(valueForm.status==0&&valueForm.referencePurchaseOrderUpdateId)){
      if(valueForm.status==5||(valueForm.status==0)){
        const username = localStorage.getItem('username')
        if(username.toLowerCase()==valueForm.requesterUser.toLowerCase() || username.toLocaleLowerCase()==valueForm.createdUser.toLowerCase()){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    }else{
      return false
    }
  }

  const [showViewVendorEmail, setShowViewVendorEmail] = React.useState(false)

  return (
    <React.Fragment>
      <StdCard title='Summary' style={{marginTop:'15px'}}
        accessoriesHeader={
          checkShowReloadSAP()?
          <React.Fragment>
            <Button 
              type='button'
              content='Unlock' 
              color='orange' 
              icon='lock open' 
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={()=>props.unlockPoSAP(valueForm.sapNumber)}
            />
            <Button 
              type='button'
              content='Reload data' 
              color='blue' 
              icon='redo' 
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={()=>props.reloadPoSAP(valueForm.id)}
            />
          </React.Fragment>:null
        }
      >
        <SummaryContainer>
          <Cont>
            <RowFields>
              <Field
                name='vendorName'
                label='Vendor Name'
                type={type.text}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
              <div style={{alignSelf:'center'}}>
                <b style={{fontSize:'12px'}}>{`Status : EzProcure ${vendorStatus.registered?"":'not'} Registered`}</b>
                {vendorStatus.registered?
                <Button 
                  type='button'
                  content='View email' 
                  // color='green' 
                  icon='mail' 
                  labelPosition='right'
                  style={{ marginLeft: '1rem' }}
                  onClick={()=>setShowViewVendorEmail(true)}
                  />:null}
              </div>
            </RowFields>
            <RowFields>
              <div style={{alignSelf:'center'}}>
                <b style={{fontSize:'12px'}}>
                  Code of Conduct : 
                  {
                    (vendorCode || '').startsWith('2') || (vendorCode || '').startsWith('4') || 
                    (vendorCode || '').startsWith('6') || (vendorCode || '').startsWith('9') || 
                    (vendorCode || '').startsWith('E') ? 
                    <div style={{ marginLeft: '5px', fontSize:'12px', color: v.textStatusColors[17] }}>Excepted</div> : 
                    valueForm.cocId ? <a href={codeOfConductDetailsPath(valueForm.cocId)} target='_blank' style={{ marginLeft: '5px', fontSize:'12px', color: v.textStatusColors[valueForm.cocStatus] }}>{valueForm.cocStatusName}</a> :
                    <div style={{ marginLeft: '5px' }}>-</div>
                  }
                </b>
              </div>
            </RowFields>
            <RowFields>
              <Field
                name='sapNumber'
                label='PO No.'
                type={type.text}
                component={FieldInput}
                editable={false}
              />
              <Field
                name='revision'
                label='PO Version'
                type={type.text}
                component={FieldInput}
                editable={false}
              />
            </RowFields>
            <RowFields>
              <Field
                name='totalAmount'
                label='Total Amount'
                type={type.number}
                suffix={`  ${valueForm.currencyCode||''}`}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
            </RowFields>
            <RowFields>
              <Field
                name='discount'
                label='Discount'
                type={type.number}
                suffix={`  ${valueForm.currencyCode||''}`}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
            </RowFields>
            <RowFields>
              <Field
                name='afterDiscount'
                label='After Discount Amount'
                type={type.number}
                suffix={`  ${valueForm.currencyCode||''}`}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
            </RowFields>
            <RowFields>
              <Field
                name='vatAmount'
                label={`VAT (${valueForm.vatRate||'0'}%)`}
                type={type.number}
                suffix={`  ${valueForm.currencyCode||''}`}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
            </RowFields>
            <RowFields>
              <Field
                name='netAmount'
                label='Net Amount'
                type={type.number}
                suffix={`  ${valueForm.currencyCode||''}`}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
            </RowFields>
            <RowFields>
              <Field
                name='remark'
                label='Remark'
                type={type.textArea}
                component={FieldInput}
                editable={false}
              />
            </RowFields>
          </Cont>
        </SummaryContainer>
      </StdCard>
      {
        valueForm.downPaymentAmount ? 
        <StdCard title='Down Payment Request' style={{ marginTop: '10px' }}>
          <SummaryContainer>
            <Cont>
              <RowFields>
                <Field
                  name='downPaymentAmount'
                  label='Down Payment Amount'
                  type={type.number}
                  suffix={`  ${valueForm.currencyCode||''}`}
                  component={FieldInput}
                  editable={false}
                  className='halfRow'
                />
              </RowFields>
              <RowFields>
                <Field
                  name='downPaymentVatAmount'
                  label={`VAT (${valueForm.downPaymentVatRate||'0'}%)`}
                  type={type.number}
                  suffix={`  ${valueForm.currencyCode||''}`}
                  component={FieldInput}
                  editable={false}
                  className='halfRow'
                />
              </RowFields>
              <RowFields>
                <Field
                  name='downPaymentNetAmount'
                  label='Net Amount'
                  type={type.number}
                  suffix={`  ${valueForm.currencyCode||''}`}
                  component={FieldInput}
                  editable={false}
                  className='halfRow'
                />
              </RowFields>
            </Cont>
          </SummaryContainer>
        </StdCard> : null
      }
      <Modal
        onClose={() => setShowViewVendorEmail(false)}
        open={showViewVendorEmail}
        size='mini'
      >
        <Modal.Header>Vendor Email</Modal.Header>
        <Modal.Content image>
          <div className='content' style={{display:'flex',flexDirection:'column'}}>
            {vendorStatus.emails?vendorStatus.emails.map((x)=>{
              return <b>{x}</b>
            }):null}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="Close"
            onClick={() => setShowViewVendorEmail(false)}
            color='green'
          />
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  vendorStatus: state.po.vendorStatus,
  valueForm : getFormValues('formPO')(state)||{}
})

const mapDispatchToProps = {
  unlockPoSAP,
  reloadPoSAP,
  getVendorStatus
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderSummary)